/* eslint-disable react-hooks/rules-of-hooks */
import { decodeToken } from 'react-jwt';

import axios from 'src/utils/axios';

const isValidToken = (token: string) => {
  if (!token) {
    return false;
  }

  const decoded: any = decodeToken(token);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const setSession = (token: string | null, portalType?: string) => {
  if (token) {
    localStorage.setItem(`${portalType?.toLowerCase()}-token`, token);

    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(`${portalType?.toLowerCase()}-token`);
    delete axios.defaults.headers.common.Authorization;
  }
};

const setRefreshToken = (refreshToken: string | null, portalType?: string) => {
  if (refreshToken) {
    localStorage.setItem(`${portalType?.toLowerCase()}-refresh-token`, refreshToken);

    axios.defaults.headers.common['refresh-token'] = refreshToken;
  } else {
    localStorage.removeItem(`${portalType?.toLowerCase()}-refresh-token`);
    delete axios.defaults.headers.common['refresh-token'];
  }
};

const sign = (payload: any, privateKey: string, header: any) => {
  const now = new Date();
  header.expiresIn = new Date(now.getTime() + header.expiresIn);
  const encodedHeader = btoa(JSON.stringify(header));
  const encodedPayload = btoa(JSON.stringify(payload));
  const signature = btoa(
    Array.from(encodedPayload)
      .map((item, key) =>
        String.fromCharCode(item.charCodeAt(0) ^ privateKey[key % privateKey.length].charCodeAt(0)),
      )
      .join(''),
  );

  return `${encodedHeader}.${encodedPayload}.${signature}`;
};

const verify = (token: string, privateKey: string) => {
  const [encodedHeader, encodedPayload, signature] = token.split('.');
  const header = JSON.parse(atob(encodedHeader));
  const payload = JSON.parse(atob(encodedPayload));
  const now = new Date();

  if (now < header.expiresIn) {
    throw new Error('Expired token');
  }

  const verifiedSignature = btoa(
    Array.from(encodedPayload)
      .map((item, key) =>
        String.fromCharCode(item.charCodeAt(0) ^ privateKey[key % privateKey.length].charCodeAt(0)),
      )
      .join(''),
  );

  if (verifiedSignature !== signature) {
    throw new Error('Invalid signature');
  }

  return payload;
};

export { isValidToken, setSession, setRefreshToken, sign, verify };
